import * as React from 'react'
import classNames from 'classnames'

export interface ButtonProps extends React.ComponentPropsWithoutRef<'button'> {
	size?: 'sm' | 'md' | 'full'
	variant?: 'primary' | 'secondary'
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
	(
		{
			children,
			size = 'full',
			onClick,
			type = 'button',
			className,
			variant = 'primary',
			'aria-label': ariaLabel,
			...rest
		},
		forwardedRef,
	) => (
		<button
			type={type}
			onClick={onClick}
			ref={forwardedRef}
			aria-label={ariaLabel}
			{...rest}
			className={classNames(
				`rounded-xl md:px-3 px-1 text-center shadow-xl h-[60px] md:h-14 uppercase text-xs font-bold tracking-wider transition-colors duration-300 ${className}`,
				{
					'w-32': size === 'sm',
					'w-64': size === 'md',
					'w-full': size === 'full',
					'bg-brand-primary-md hover:bg-brand-primary-md hover:text-white text-white': variant === 'primary',
					'bg-white text-brand-primary-md border-2 border-brand-primary-md': variant === 'secondary',
				},
			)}
		>
			{children}
		</button>
	),
)

Button.displayName = 'Button'
export default Button
